import pkg from '../../package.json';
import { ROLLBAR_TOKEN } from '../config/environment';

const version = pkg.version ?? '0.0.0';

export const rollbarConfig = {
  accessToken: ROLLBAR_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: import.meta.env.VITE_DISABLE_VENDORS !== 'true',
  ignoredMessages: [
    'ResizeObserver loop',
    'Unexpected error occurred. Please contact Saleswhale support with the error reference code',
    'Network request failed',
    'Token is invalid',
    'Token is expired',
    'Unauthorized',
    'Script error.',
    'AbortError: Aborted',
    'Object Not Found Matching Id',
    'NotAllowedError: The request is not allowed by the user agent',
    'NotAllowedError',
  ],
  payload: {
    environment: import.meta.env.VITE_APP_ENV || 'local',
    code_version: version,
    client: {
      javascript: {
        source_map_enabled: true,
        code_version: version,
      },
    },
  },
};
